<template>
  <NuxtImg
    src="/icons/membership-icon-filled2.svg"
    loading="lazy"
    style="max-width: 20px; min-width: 20px"
    alt="user icon"
    provider="cloudflare"
    preload
  />
</template>

<script setup></script>
